
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/oracle",
      function () {
        return require("private-next-pages/sources/oracle.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/oracle"])
      });
    }
  